module.exports = __webpack_public_path__ + "static/img/no_image_found.0383a250.png";